// Decode the logged in user's JWT payload.
export const decodeToken = (token) => {
  if (!token) {
    return {};
  }

  try {
    const base64Url = token.split(".")[1];
    if (!base64Url) {
      return {};
    }

    const base64 = base64Url.replace(/-/g, "+").replace(/_/g, "/");
    const paddedBase64 = base64.padEnd(base64.length + ((4 - (base64.length % 4)) % 4), "=");
    const payload = JSON.parse(window.atob(paddedBase64));
    const exp = Number(payload.exp);

    return {
      ...payload,
      id: payload.id || payload._id || payload.userId || payload.userID || payload.sub || null,
      exp: Number.isFinite(exp) ? exp : null,
    };
  } catch {
    return {};
  }
};
